module.exports = __webpack_public_path__ + "static/img/Bachelor_010309.a6acfb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010309.jpg
// module id = 146
// module chunks = 0